<nz-card style="margin-bottom: 10px;">
  <nz-spin [nzSpinning]="loading">


    <div class="query-condition-box margin-top-10 padding-bottom-10">
      <div>
        <form nz-form [formGroup]="validateForm">
          <div class="条件区">
            <!-- 第一行 -->
            <div nz-row>
              <div nz-col nzSpan="2" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Site" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="20">
                    <nz-select formControlName="Site" (ngModelChange)="valuehandleChange()"
                      nzPlaceHolder="{{'ALL'|translate}}" nzAllowClear>
                      <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName"
                        [nzValue]="option.siteCode">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowBuyer">
                <nz-form-label *ngIf="UserRequestlimits">
                  <div class="width-100-percent label-font">
                    {{ "Buyer" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Buyer" nzShowSearch
                      nzAllowClear (nzOnSearch)="BuyerSearch($event)" (ngModelChange)="valuehandleChange()"
                      nzPlaceHolder="{{'ALL'|translate}}">
                      <nz-option *ngFor="let option of BuyerList" [nzLabel]="option.buyerName"
                        [nzValue]="option.buyer"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="8" *ngIf="ShowVendor">

                <nz-form-label *ngIf="UserRequestlimits">
                  <div class="width-100-percent label-font">
                    {{ "VendorName" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="20">

                    <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Vendor"
                      (nzOnSearch)="VendorSearch($event)" style="border-radius:6px;" nzPlaceHolder="{{'ALL'|translate}}"
                      [nzAllowClear]="true" [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of VendorList" [nzValue]="o.vendorCode" nzLabel="{{o.vendorName}}"
                        nzCustomContent>
                        <span>{{o.vendorName}}</span>
                      </nz-option>
                    </nz-select>

                  </nz-form-control>
                </nz-form-item>

              </div>
            </div>
            <!-- 第二行 -->
            <div nz-row class="row-with-spacing">
              <div nz-col nzSpan="4" *ngIf="ShowTime">
                <nz-form-label nzSpan="12">
                  <div class="width-100-percent label-font">{{ "StatementMonth" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <nz-range-picker nzPlaceHolder='' formControlName="StatementMonth"
                    (ngModelChange)="valuehandleChange()"></nz-range-picker>
                </nz-form-control>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowPONO">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "table.PONO" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="PONO" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowApplyDept">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "DemandUnit" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzSpan]="22">
                    <nz-select [nzServerSearch]="true" formControlName="applyDept" (nzOnSearch)="userSearch($event)"
                      style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                      [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId"
                        nzLabel="{{o.userId}}/{{o.englishName}}" nzCustomContent>
                        <span>{{o.userId}}/{{o.englishName}}</span>
                      </nz-option>
                    </nz-select>

                  </nz-form-control>
                </nz-form-item>
              </div>


              <div nz-col nzSpan="4" *ngIf="maintainNotInvoice">
                <nz-form-label>
                  <div class="width-100-percent label-font">{{ "WhetherInvoice" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <nz-select formControlName="NotInvoice" nzAllowClear nzPlaceHolder="{{'ALL'|translate}}"
                    (ngModelChange)="valuehandleChange()">
                    <nz-option nzLabel="Y" nzValue="Y"></nz-option>
                    <nz-option nzLabel="N" nzValue="N"></nz-option>
                  </nz-select>
                </nz-form-control>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="maintainNotInvoice">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>
              <div nz-col class="row-with-spacing-button" *ngIf="ShowSecondDown">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="download" nzTheme="outline"></span>
                  {{'DownloadExcel'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="ShowSecondQuery">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="ShowSecondExport">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="export" nzTheme="outline"></span>
                  {{'Export'|translate}}
                </button>
              </div>

            </div>
            <!-- 第3行 -->
            <div nz-row class="row-with-spacing3">
              <div nz-col nzSpan="4" *ngIf="ShowNotInvoice">
                <nz-form-label>
                  <div class="width-100-percent label-font">{{ "WhetherInvoice" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <nz-select formControlName="NotInvoice" nzShowSearch nzAllowClear
                      nzPlaceHolder="{{'ALL'|translate}}" (ngModelChange)="valuehandleChange()">
                      <nz-option nzLabel="Y" nzValue="Y"></nz-option>
                      <nz-option nzLabel="N" nzValue="N"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowInvoiceNo">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "InvoiceNo" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="InvoiceNo" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowPANO">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "PANo" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="PANO" nzShowSearch nzAllowClear
                      (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowBillingStatus">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "BillingStatus" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <nz-select formControlName="BillingStatus" nzAllowClear nzMode="multiple" [nzMaxTagCount]="1"
                      [nzMaxTagPlaceholder]="maxTagPlaceholder" nzPlaceHolder="{{'ALL'|translate}}"
                      (ngModelChange)="valuehandleChange()">
                      <ng-template #maxTagPlaceholder let-selectedOptions>
                        <span class="selected-labels" [title]="BillingStatusLabels.join('\n')">+ {{
                          selectedOptions.length}}</span>
                      </ng-template>
                      <nz-option *ngFor="let option of BillingStatusOptions" [nzLabel]="option.nzLabel | translate"
                        [nzValue]="option.nzValue">
                      </nz-option>
                      <!-- <nz-option nzLabel="{{'NotRt'|translate}}" nzValue="0"></nz-option>
                      <nz-option nzLabel="{{'NotInvoice'|translate}}" nzValue="1"></nz-option>
                      <nz-option nzLabel="{{'Ongoing'|translate}}" nzValue="2"></nz-option>
                      <nz-option nzLabel="{{'Reject'|translate}}" nzValue="Reject"></nz-option>
                      <nz-option nzLabel="{{'Paymenting'|translate}}" nzValue="3"></nz-option> -->
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="1" style="margin-top: 30px;" *ngIf="ShowBillingStatus">
                <!-- <button class="default-button" nz-button nz-popover [nzPopoverContent]="contentTemplate"
                  nzPopoverPlacement="rightTop">
                  ?
                </button> -->
                <button nz-popover [nzPopoverContent]="contentTemplate"
                  style=" border: none;background-color: transparent;" nzPopoverPlacement="rightTop"><span nz-icon
                    nzType="question-circle" nzTheme="twotone" style="font-size: 24px;"></span>

                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="Query">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="Query">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="export" nzTheme="outline"></span>
                  {{'Export'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSend&&isAllowSend" nz-button nzType="primary" class="default-button"
                  (click)="SendStatementNotification()">
                  <span nz-icon nzType="send" nzTheme="outline"></span>
                  {{'Send'|translate}}
                </button>
              </div>

            </div>
          </div>
        </form>

      </div>


    </div>
  </nz-spin>
</nz-card>


<ng-template #contentTemplate>
  <div>
    <p>{{ "Visible_01" | translate }}</p>
    <p>
      {{ "Visible_02" | translate }}
    </p>
    <p>
      {{ "StVisible_03" | translate }}
    </p>
    <p>
      {{ "Visible_04" | translate }}
    </p>
    <p>
      {{ "Visible_05" | translate }}
    </p>
    <p>
      {{ "SVisible_06" | translate }}
    </p>
    <p>
      {{ "SVisible_07" | translate }}
    </p>
  </div>
</ng-template>